import { render } from "./SpecialEpisodeLabels.vue?vue&type=template&id=6a220fc8&scoped=true"
import script from "./SpecialEpisodeLabels.vue?vue&type=script&lang=js"
export * from "./SpecialEpisodeLabels.vue?vue&type=script&lang=js"

import "./SpecialEpisodeLabels.vue?vue&type=style&index=0&id=6a220fc8&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a220fc8"]])

export default __exports__